import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./BenefitItem.scss";
const BenefitItem = ({ benefitsTitle, benefitsImage }) => {
    return (_jsxs("div", { className: "benefitItem", children: [_jsx("img", { className: "benefitItem__image", src: benefitsImage, alt: "benefit image" }), _jsx("div", { className: "benefitItem__title", children: benefitsTitle })] }));
};
export default BenefitItem;
//# sourceMappingURL=BenefitItem.js.map